import { render, staticRenderFns } from "./Router.vue?vue&type=template&id=a3c8f0f6&scoped=true"
import script from "./Router.vue?vue&type=script&lang=js"
export * from "./Router.vue?vue&type=script&lang=js"
import style0 from "./Router.vue?vue&type=style&index=0&id=a3c8f0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c8f0f6",
  null
  
)

export default component.exports